<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Notification History</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

  <div *ngIf="notificationHistory.length == 0" class="alert alert-info">
    No Notification History
  </div>

  <div *ngIf="notificationHistory.length > 0" class="table-responsive">
    <table mat-table [dataSource]="notificationHistory" class="small">

      <ng-container matColumnDef="notificationHistoryTypeName">
        <mat-header-cell *matHeaderCellDef>History Type.</mat-header-cell>
        <mat-cell *matCellDef="let hist">{{hist.notificationHistoryTypeName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="byUser">
        <mat-header-cell *matHeaderCellDef>By User.</mat-header-cell>
        <mat-cell *matCellDef="let hist">{{hist.byUser.firstName}} {{hist.byUser.lastName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="dateOccured">
        <mat-header-cell *matHeaderCellDef>Date.</mat-header-cell>
        <mat-cell *matCellDef="let hist">{{formatDateWithTime(hist.dateOccured)}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="fromUser">
        <mat-header-cell *matHeaderCellDef>From User.</mat-header-cell>
        <mat-cell *matCellDef="let hist">
          <span *ngIf="hist.fromUser">{{hist.fromUser.firstName}} {{hist.fromUser.lastName}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="toUser">
        <mat-header-cell *matHeaderCellDef>To User.</mat-header-cell>
        <mat-cell *matCellDef="let hist">
          <span *ngIf="hist.fromUser">{{hist.toUser.firstName}} {{hist.toUser.lastName}}</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
      <mat-row *matRowDef="let hist; columns: displayedColumns;"></mat-row>

    </table>
  </div>

</div>